import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_SEARCH: GlameraIconDefinition = {
  name: 'search',
  viewBox: '0 0 24 24',
  svg: `
    <g class="glm-search-group">
      <circle cx="11" cy="11" r="8"></circle>
      <path d="m21 21-4.34-4.34"></path>
    </g>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-search-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './search.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class SearchIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_SEARCH;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
